import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { MDBModalRef, ToastService } from 'ng-uikit-pro-standard';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContactService } from 'src/app/services/contact.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/services/general.service';
import { EmployeesService } from '../../services/employees.service';
import { SharedDatagridModule } from '../shared-datagrid/shared-datagrid.module';
import { DatePipe } from '@angular/common';
import { DxFormComponent } from 'devextreme-angular';
import Popup from 'devextreme/ui/popup'; 
declare var $: any;
import { TranslateService } from '@ngx-translate/core';
import { SalesProjectService } from 'src/app/services/sales-project.service';
@Component({
  selector: 'app-new-employee',
  templateUrl: './new-employee.component.html',
  styleUrls: ['./new-employee.component.scss']
})
export class NewEmployeeeComponent implements OnInit {
  // @ViewChild(DxFormComponent, { static: false }) myform: DxFormComponent;
  newEmployeeForm: FormGroup;
  @Output() cloeModal = new EventEmitter();
  @Output() result = new EventEmitter();
  @Input() popupNewEmployee: boolean;
  @Input() isSales: boolean;

  //Listas de Formulario
  departments: any = [];
  jobCode: any = [];
  supervisors: any = [];
  employmentType: any = [];
  submited = false;
  // popupNewEmployee = false;
  responsible: { value: string; label: string; }[] = [];

  BirthDateDate:number
  todayButtonBirthDateDate: any;
  prevDateButtonBirthDateDate: any;
  nextDateButtonBirthDateDate: any;

  HireDateDate:number
  todayButtonHireDateDate: any;
  prevDateButtonHireDateDate: any;
  nextDateButtonHireDateDate: any;

  TerminationDateDate:number
  todayButtonTerminationDateDate: any;
  prevDateButtonTerminationDateDate: any;
  nextDateButtonTerminationDateDate: any;

  millisecondsInDay = 24 * 60 * 60 * 1000;




  constructor(
    private contactService: ContactService,
    private router: Router,
    private generalService: GeneralService,
    private toast: ToastService,
    private employeesService: EmployeesService,
    private datepipe: DatePipe,
    private datagrid: SharedDatagridModule,
    private translate:TranslateService,
    private SalesProjectService: SalesProjectService,
  ) {

    Popup.defaultOptions({
          device: { deviceType: "phone" },
          options: {
            fullScreen: true,

          }
        });
    this.todayButtonBirthDateDate = {
      text: this.translate.instant('btnToday'),
      onClick: () => {
          this.BirthDateDate = new Date().getTime();
      }
    };

    this.prevDateButtonBirthDateDate = {
        icon: "spinprev",
        stylingMode: "text",
        onClick: () => {
          this.BirthDateDate -= this.millisecondsInDay;
        }
    };

    this.nextDateButtonBirthDateDate = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.BirthDateDate += this.millisecondsInDay;
      }
    };

    this.todayButtonHireDateDate = {
      text: this.translate.instant('btnToday'),
      onClick: () => {
          this.HireDateDate = new Date().getTime();
      }
    };

    this.prevDateButtonHireDateDate = {
        icon: "spinprev",
        stylingMode: "text",
        onClick: () => {
          this.HireDateDate -= this.millisecondsInDay;
        }
    };

    this.nextDateButtonHireDateDate = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.HireDateDate += this.millisecondsInDay;
      }
    };

    this.todayButtonTerminationDateDate = {
      text: this.translate.instant('btnToday'),
      onClick: () => {
          this.TerminationDateDate = new Date().getTime();
      }
    };

    this.prevDateButtonTerminationDateDate = {
        icon: "spinprev",
        stylingMode: "text",
        onClick: () => {
          this.TerminationDateDate -= this.millisecondsInDay;
        }
    };

    this.nextDateButtonTerminationDateDate = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.TerminationDateDate += this.millisecondsInDay;
      }
    };

   }

  ngOnInit() {
    this.responsible = [{ value: 'hplaa', label: 'hola' }]
    this.startForms();
    this.getDepartments();
    this.getJobCode();
    this.getSupervisors();
    this.getEmploymentType();
  }
  ngAfterViewInit() {
    // this.myform.instance.validate()
  }

  startForms() {

    this.newEmployeeForm = new FormGroup({
      EmployeeNumber: new FormControl('', []),
      FirstName: new FormControl(null, [Validators.pattern('[a-zA-Z ]*'), Validators.required]),
      LastName: new FormControl(null, [Validators.pattern('[a-zA-Z ]*'), Validators.required]),
      BirthDate: new FormControl('', []),
      Department: new FormControl('', []),
      JobCode: new FormControl('', []),
      Supervisor: new FormControl('', []),
      EmploymentType: new FormControl(0, []),
      Active: new FormControl(true, []),
      MobilePhone: new FormControl('', []),
      Email: new FormControl('', []),
      EmergencyContactName: new FormControl('', []),
      EmergencyContactNumber: new FormControl('', []),
      Address: new FormControl('', []),
      HireDate: new FormControl(null, []),
      TerminationDate: new FormControl(null, []),
    })
  }

  submitForm(action) {

    let form = this.newEmployeeForm.value;
    let date = '';
    if (!this.newEmployeeForm.controls.FirstName.valid) {
      this.toast.error('First Name invalid');
      return false;
    }
    if (!this.newEmployeeForm.controls.LastName.valid) {
      this.toast.error('Last Name invalid');
      return false;
    }

    if (form.BirthDate != undefined && form.BirthDate != ''){
      date = this.datepipe.transform(new Date(form.BirthDate), 'yyyyMMdd')
    }

    let date1 = ""
    if (form.HireDate != undefined && form.HireDate != ""){
      date1 = this.datepipe.transform(new Date(form.HireDate), 'yyyyMMdd')
    }
    let date2 = ""
    if (form.TerminationDate != undefined && form.TerminationDate != ""){
      date2 = this.datepipe.transform(new Date(form.TerminationDate), 'yyyyMMdd')
    }


    form.Active == false ? form.Active = '0' : form.Active = '1';


    this.employeesService.InsertEmployee(
      form.FirstName,
      form.LastName,
      form.EmployeeNumber,
      form.Active,
      form.Email,
      form.MobilePhone,
      form.EmergencyContactName,
      form.EmergencyContactNumber,
      form.Address,
      form.JobCode,
      form.Department,
      form.EmploymentType,
      form.Supervisor,
      date,date1,
      date2).subscribe(result => {
        console.log(result)

        if (result[0].ResultiID != 0) {
          if(this.isSales){
            this.SalesProjectService.UpdateEmployeeToSales(result[0].ResultiID).subscribe(result => {
            });
          }
        }
        this.newEmployeeForm.reset()
        this.success()
        // this.datagrid.reloadComponent()
        console.log(action)
        switch (action) {
          case 'save':
            this.popupNewEmployee = false;
            console.log(result[0])
            // form.id = result[0].ReturnID
            this.result.emit(result[0]);
            this.cloeModal.emit(false);
            console.log('paso')
            break;
          case 'new':
            this.newEmployeeForm.reset();
            break;
        }
      })


    //SP_API_Flex_Get_HumanResourcesAll
    //SP_API_Flex_Get_EmployeeListAll
  }


  handleAddressChange(res) {
    console.log(res.formatted_address)
    this.newEmployeeForm.get('Address').setValue(res.formatted_address);
  }

  success() {
    this.toast.success(this.translate.instant('msgEmpCreSucc'));
  }

  getDepartments() {
    this.employeesService.GetDepartments().subscribe(result => {
      // console.log('Departamentos', result);
      // this.departments = result;
      this.departments = result.map((val) => {
        return {
          name: val.NAME,
          id: val.ID
        }
      })
    })
  }

  getJobCode() {
    this.employeesService.GetJobCode().subscribe(result => {
      // console.log('Job Code', result)
      this.jobCode = result.map((val) => {
        return {
          id: val.ID,
          name: val.DESCRIPTION
        }
      });
      this.newEmployeeForm.get('JobCode').setValue(this.jobCode[0].id)
    })
  }

  getSupervisors() {
    this.employeesService.GetSupervisor().subscribe(result => {
      // console.log('Supervisors', result)
      this.supervisors = result.map((val) => {
        return {
          id: val.ID,
          name: val.CONTACTNAME
        }
      });
    })
  }

  getEmploymentType() {
    this.employeesService.GetEmploymentType().subscribe(result => {
      // console.log('Employment Type', result)
      this.employmentType = result.map((val) => {
        return {
          id: val.ID,
          name: val.EMPLOYMENTTYPE
        }
      });
    })
  }

  CerrarEmployee() {
    this.startForms()
    this.cloeModal.emit(true);
  }

}
